module.exports = "<spk-card [class]=\"'col-md-3'\" meta=\"{{ getActionText() }} Example\" title=\"{{model.DisplayText}}\" [divider]=\"true\">\r\n  <formly-form [fields]=\"fields\" [model]=\"model\" [options]=\"options\" [form]=\"form\"> </formly-form>\r\n</spk-card>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/examples/full-crud-example/example-formly/example-formly.component.html
// module id = ./src/app/components/examples/full-crud-example/example-formly/example-formly.component.html
// module chunks = main